import { Navigate, Route, Routes } from 'react-router-dom'
import Clients from '../../features/users/Clients'
import NewClient from '../../features/users/NewClient'
import AllClients from '../../features/users/AllClients'
import ModifyClient from '../../features/users/ModifyClient'
import Orders from '../../features/orders/Orders'
import AllOrders from '../../features/orders/AllOrders'
import ManageOrder from '../../features/orders/ManageOrder'
import { useAppSelector } from '../redux/store'

export default function UsersRoutes() {
  const role = useAppSelector((state) => state.auth.role)

  return (
    <Routes>
      {(role === 'admin' || role === 'moderator') && (
        <>
          <Route path="*" element={<Navigate to={'/users/clients/all'} />} />
          <Route path="moderators" element={<>moderators</>} />
          <Route path="clients/*" element={<Clients />} />
        </>
      )}
      {(role === 'admin' || role === 'muzred') && (
        <>
          <Route path="orders/*" element={<Orders />} />  
          <Route path="orders/manage/:id" element={<ManageOrder />} />
        </>
      )}
    </Routes>
  )
}

export function OrdersRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/users/orders/all'} />} />
      <Route path="all" element={<AllOrders/>} />
    </Routes>
  )
}


export function ClientsRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/users/clients/all'} />} />
      <Route path="all" element={<AllClients />} />
      <Route path="new" element={<NewClient />} />
      <Route path=":id/modify" element={<ModifyClient />} />
    </Routes>
  )
}
